/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * VSD API
 * API for the Victim Services Directory (VSD) application
 * OpenAPI spec version: v1
 */
import type {
  HttpResponse as AngularHttpResponse,
  HttpContext,
  HttpEvent,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import type { InvoiceDto } from '../../model';

type HttpClientOptions = {
  headers?:
    | HttpHeaders
    | {
        [header: string]: string | string[];
      };
  context?: HttpContext;
  observe?: any;
  params?:
    | HttpParams
    | {
        [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
      };
  reportProgress?: boolean;
  responseType?: any;
  withCredentials?: boolean;
};

@Injectable({ providedIn: 'root' })
export class InvoicesService {
  constructor(private http: HttpClient) {}
  postApiInvoices<TData = void>(
    invoiceDto: InvoiceDto,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  postApiInvoices<TData = void>(
    invoiceDto: InvoiceDto,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  postApiInvoices<TData = void>(
    invoiceDto: InvoiceDto,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  postApiInvoices<TData = void>(invoiceDto: InvoiceDto, options?: HttpClientOptions): Observable<TData> {
    return this.http.post<TData>(`/cvapwebform/api/Invoices`, invoiceDto, options);
  }
}

export type PostApiInvoicesClientResult = NonNullable<void>;
